import Vue from 'vue';
import Vuex from 'vuex';

import helper from "store/helper-store";

import empresa from "store/empresa-store";
import usuarios from "store/usuarios-store";
import reportes from "store/reportes-store";
import clientes from "store/clientes-store";
import inspeccion from "store/inspeccion-store";
import accesorios from "store/accesorios-store";
import acciones from "store/acciones-store";
import fotosvideo from "store/fotosvideo-store";
import ciudades from "store/ciudades-store";
import sidebar from "store/sidebar-store";
import buscador from "store/buscador-store";
import propuesta from "store/propuesta-store";
import embudo from "store/embudo-store";
import fichaTecnica from "store/fichaTecnica-store";
import dashboard from "store/dashboard-store";
import notifications from "store/notifications-store";

import fichaVentaPanel from "store/fichaventa/panel-store";
/**Prospecto Detalle */
import prospectoPanel from "store/prospecto/panel-store";
import prospectoNecesidad from "store/prospecto/necesidad-store";
import prospectoCita from "store/prospecto/cita-store";
import prospectoPotencial from "store/prospecto/potencial-store";
import prospectoInspeccion from "store/prospecto/inspeccion-store";
import prospectoNegociacion from "store/prospecto/negociacion-store";
import prospectoCierre from "store/prospecto/cierre-store";
/** Conseguir */
import conseguir from "store/conseguir-store"
/**Credito Detalle */
import creditoPanel from "store/credito/panel-store";
import creditoSteps from "store/credito/steps-store";
/**Consignacion Final */
import consignacionModals from "store/consignacion/modals-store";
/**Reporte consignacion */
import reportePanel from "store/reporte/panel-store";
import reporteCotizacion from "store/reporte/cotizacion-store";
import reporteVehiculo from "store/reporte/vehiculo-store";
import reporteLegal from "store/reporte/legal-store";
import reporteInspeccion from "store/reporte/inspeccion-store";
import reporteGastos from "store/reporte/gastos-store";
import reportePublicacion from "store/reporte/publicacion-store";

/**Tareas*/
import tareas from "store/tareas-store";

/**Citas*/
import citas from "store/citas-store";

/**Inspeccion detalle*/
import inspeccionEncuesta from "store/inspeccion/encuesta-store";
import inspeccionGeneral from "store/inspeccion/general-store";
import inspeccionRevision from "store/inspeccion/revision-store";
/**Detalle prospecto */

/**Admin Venta*/
import adminventaModals from "store/adminventa/modals-store";
import adminventaRecaudo from "store/adminventa/recaudo-store";
import adminCarpeta from "store/adminventa/carpeta-store";
import adminSoportes from "store/adminventa/soportes-store";

import proceso from "store/proceso-store";
/**Frontend */
import vender from "store/frontend/vender-store";
import financiar from "store/frontend/financiar-store";
import testDrive from "store/frontend/testDrive-store";
import ofertar from "store/frontend/ofertar-store";
import ventasStore from 'store/ventas-store';
/**Facturacion */
import facturacion from 'store/facturacion-store';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        helper: helper,
        /**Reporte Store */
        reporte_panel: reportePanel,
        reporte_cotizacion: reporteCotizacion,
        reporte_vehiculo: reporteVehiculo,
        reporte_legal: reporteLegal,
        reporte_inspeccion: reporteInspeccion,
        reporte_gastos: reporteGastos,
        reporte_publicacion: reportePublicacion,
        /**Inspeccion store */
        inspeccion_encuesta: inspeccionEncuesta,
        inspeccion_general: inspeccionGeneral,
        inspeccion_revision: inspeccionRevision,
        /**Prospectos store */
        prospecto_panel: prospectoPanel,
        prospecto_necesidad: prospectoNecesidad,
        prospecto_cita: prospectoCita,
        prospecto_potencial: prospectoPotencial,
        prospecto_inspeccion: prospectoInspeccion,
        prospecto_negociacion: prospectoNegociacion,
        prospecto_cierre: prospectoCierre,
        credito_panel: creditoPanel,
        credito_steps: creditoSteps,
        ficha_panel: fichaVentaPanel,
        /**Admin Venta*/
        adminventa_modals: adminventaModals,
        adminventa_recaudo: adminventaRecaudo,
        consignacion_modals: consignacionModals,
        adminventa_carpeta: adminCarpeta,
        adminventa_soportes: adminSoportes,
        /**Conseguir */
        conseguir: conseguir,
        /**Notificaciones */
        notifications: notifications,
        /**Front */
        vender: vender,
        financiar: financiar,
        testDrive: testDrive,
        empresa: empresa,
        usuarios: usuarios,
        reportes: reportes,
        clientes: clientes,
        inspeccion: inspeccion,
        accesorios: accesorios,
        acciones: acciones,
        fotosvideo: fotosvideo,
        ciudades: ciudades,
        fichaTecnica: fichaTecnica,
        sidebar: sidebar,
        buscador: buscador,
        propuesta: propuesta,
        embudo: embudo,
        dashboard: dashboard,
        proceso: proceso,
        ventas: ventasStore,
        ofertar: ofertar,
        /**Tareas */
        tareas: tareas,
        /**Citas */
        citas: citas,
        /**Facturacion */
        facturacion: facturacion
    }
});
